module.exports = __webpack_public_path__ + "media/building-trx.2478da08.mp4";